import React from 'react';

const Loader = () => {
  return (
    <div className="ring-loader-container">
      <div className="ring-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
